import styled from "styled-components";
import { colors } from "globalStyles";

export const Wrapper = styled.div`
  padding: 24px 0;

  h1 {
    font-size: 24px;
    font-weight: bold;
    color: ${colors.DARK_GRAY};
    margin-bottom: 16px;
  }

  .admin-users__error,
  .admin-users__empty {
    font-size: 14px;
    font-weight: normal;
    color: ${colors.MEDIUM_GRAY};
    padding: 24px 0;
  }
`;

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

const controlStyles = `
  height: 38px;
  padding: 0 12px;
  border: 1px solid ${colors.LIGHT_GRAY};
  border-radius: 6px;
  font-size: 14px;
  color: ${colors.DARK_GRAY};
  background: ${colors.WHITE};
`;

// RoleSelect is used by the create form (NewUser); the list no longer filters
// by role (the server param was phantom).
export const RoleSelect = styled.select`
  ${controlStyles}
  flex: 0 0 auto;
`;

export const NewButton = styled.button`
  ${controlStyles}
  cursor: pointer;
  font-weight: bold;
  color: ${colors.WHITE};
  background: ${colors.SILKBLUE};
  border-color: ${colors.SILKBLUE};
`;

export const BackLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-bottom: 16px;
  cursor: pointer;
  font-size: 13px;
  color: ${colors.SILKBLUE};
`;

export const DetailHeading = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 24px;

  .admin-users__role {
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${colors.MEDIUM_GRAY};
  }
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

// A real <label> for form controls — pair with htmlFor (see NewUser).
export const FieldLabel = styled.label`
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${colors.MEDIUM_GRAY};
`;

// Display-only field caption for the read-only detail view. A <span>, not a
// <label>, since it labels static text rather than a form control — an
// htmlFor-less <label> is an a11y smell (orphaned label).
export const DetailLabel = styled.span`
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${colors.MEDIUM_GRAY};
`;

export const FieldValue = styled.div`
  font-size: 15px;
  color: ${colors.DARK_GRAY};
`;

export const Form = styled.form`
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TextInput = styled.input`
  ${controlStyles}
`;

export const SubmitButton = styled.button`
  ${controlStyles}
  margin-top: 8px;
  cursor: pointer;
  font-weight: bold;
  color: ${colors.WHITE};
  background: ${colors.SILKBLUE};
  border-color: ${colors.SILKBLUE};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const FormError = styled.div`
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 13px;
  color: ${colors.DANGER_FG};
  background: ${colors.DANGER_BG};
`;

// Mutations section (UserActions) beneath the read-only detail.
export const ActionsWrapper = styled.div`
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid ${colors.LIGHT_GRAY};
  display: flex;
  flex-direction: column;
  gap: 16px;

  h2 {
    font-size: 16px;
    font-weight: bold;
    color: ${colors.DARK_GRAY};
  }
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`;

export const ConfirmRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 13px;
  color: ${colors.DARK_GRAY};
`;

export const SecondaryButton = styled.button`
  ${controlStyles}
  cursor: pointer;
  font-weight: bold;
  color: ${colors.DARK_GRAY};
`;

export const DangerButton = styled.button`
  ${controlStyles}
  cursor: pointer;
  font-weight: bold;
  color: ${colors.WHITE};
  background: ${colors.DANGER_FG};
  border-color: ${colors.DANGER_FG};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
